module.exports = __webpack_public_path__ + "4348514a01b043efa7279cd044654dbd.svg";